export default __webpack_public_path__ + "static/media/location-Icon.fcb28610.svg";